var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivity = function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 14.667h4c3.334 0 4.667-1.333 4.667-4.667V6c0-3.333-1.333-4.666-4.667-4.666H6C2.667 1.334 1.334 2.667 1.334 6v4c0 3.334 1.333 4.667 4.666 4.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.887 9.66 6.473 7.6a.67.67 0 0 1 .94-.12l1.22.96a.674.674 0 0 0 .94-.113l1.54-1.987"
  })));
};
export default SvgActivity;